import { SvgComponent } from "../../../types/svg-component"
import BookIcon from "../../media/icons/book.svg"
import HeadphonesIcon from "../../media/icons/headphones.svg"
import ScreenIcon from "../../media/icons/screen.svg"

type DurationMinsProps = {
  type?: string
  length?: string
}

const ICON_MAP: Record<string, { component: SvgComponent; label: string }> = {
  "guide-and-toolkit": { component: BookIcon, label: "read" },
  report: { component: BookIcon, label: "read" },
  article: { component: BookIcon, label: "read" },
  video: { component: ScreenIcon, label: "watch" },
  webinar: { component: ScreenIcon, label: "watch" },
  podcast_episode: { component: HeadphonesIcon, label: "listen" },
}

export default function DurationMins({ type, length }: DurationMinsProps) {
  const item = type ? ICON_MAP[type] : undefined

  return (
    <div className="flex items-center gap-8">
      {length && length !== " min" && (
        <span className="eyebrow">
          {length} {item?.label}
        </span>
      )}
      {item && (
        <item.component
          className="opacity-75 size-12"
          color="black"
          aria-hidden="true"
        />
      )}
    </div>
  )
}
